export default __webpack_public_path__ + "static/media/PawPatrol_04.e51bda00.png";